import { renderInDocument } from '@spotahome/soyuz/client';

import AmbassadorContainer from './main';

renderInDocument(AmbassadorContainer);
